(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0964/4988/8621/files/';

  var STAINS = {
    everstain: {
      name: 'EverStain™ Acid Stain',
      tag: 'Acid stain',
      look: 'Marbled & natural',
      lookDesc: 'Translucent color with organic movement and variation',
      best: 'Best when you want a natural, one-of-a-kind result on porous concrete.',
      trial: 'https://directcolors.com/products/acid-concrete-stain-sample-kit',
      learn: 'https://directcolors.com/products/acid-concrete-stain',
      price: '$39.95',
      benefits: [
        'Reactive color becomes part of the concrete rather than a paint-like layer',
        'Creates translucent, marbled variation unique to each slab',
        'Designed for porous interior or exterior concrete'
      ],
      specs: [['Use', 'Interior & exterior'], ['Finish', 'Translucent, marbled'], ['Surface', 'Porous concrete'], ['Sealing', 'Required']]
    },
    colorwave: {
      name: 'ColorWave® Water-Based Stain',
      tag: 'Water-based stain',
      look: 'Rich & even color',
      lookDesc: 'More predictable coverage with a broad color palette',
      best: 'Best when color consistency and easy visual control matter most.',
      trial: 'https://directcolors.com/products/water-based-concrete-stain-sample-kit',
      learn: 'https://directcolors.com/products/water-based-concrete-stain',
      price: '$39.95',
      benefits: [
        'Rich, more predictable color with less natural mottling',
        'Low-odor, low-VOC water-based formula',
        'Works on many properly prepared interior and exterior concrete surfaces'
      ],
      specs: [['Use', 'Interior & exterior'], ['Finish', 'Even, consistent'], ['Base', 'Water-based'], ['Sealing', 'Required']]
    },
    vibrance: {
      name: 'Vibrance™ Concrete Dye',
      tag: 'Concrete dye',
      look: 'Bold & modern',
      lookDesc: 'Vivid color made for smooth or polished interior concrete',
      best: 'Best for vivid, contemporary color on smooth interior slabs.',
      trial: 'https://directcolors.com/products/concrete-dye-powder-sample-kit',
      learn: 'https://directcolors.com/products/concrete-dye-powder',
      price: '$39.95',
      benefits: [
        'Bold, vivid color for a modern finished look',
        'Fast-drying acetone dye system',
        'Especially suited to smooth or polished interior concrete'
      ],
      specs: [['Use', 'Interior'], ['Finish', 'Vivid, modern'], ['Surface', 'Smooth concrete'], ['Sealing', 'Required']]
    },
    portico: {
      name: 'Portico™ Paver Stain',
      tag: 'Solvent-based paver stain',
      look: 'Rich & saturated',
      lookDesc: 'Deep color that restores and recolors concrete pavers',
      best: 'Best for maximum color depth on faded exterior pavers.',
      trial: 'https://directcolors.com/products/concrete-paver-stain-sample-kit',
      learn: 'https://directcolors.com/products/concrete-paver-stain',
      price: '$39.95',
      benefits: [
        'Made specifically to restore faded concrete pavers',
        'Deep, saturated color for patios, walkways and driveways',
        'A cost-conscious alternative to replacing structurally sound pavers'
      ],
      specs: [['Use', 'Exterior'], ['Finish', 'Rich, opaque'], ['Surface', 'Concrete pavers'], ['Sealing', 'System dependent']]
    },
    pavewave: {
      name: 'PaveWave™ Water-Based Paver Stain',
      tag: 'Water-based paver stain',
      look: 'Even & low-odor',
      lookDesc: 'Paver-specific color for occupied or odor-sensitive areas',
      best: 'Best for pavers when a water-based, lower-odor system is preferred.',
      trial: 'https://directcolors.com/products/water-based-paver-stain-sample-kit',
      learn: 'https://directcolors.com/products/water-based-paver-stain',
      price: '$39.95',
      benefits: [
        'Water-based, low-odor formula made for concrete pavers',
        'Even, saturated color with straightforward application',
        'A practical option for occupied or odor-sensitive areas'
      ],
      specs: [['Use', 'Exterior'], ['Finish', 'Even, saturated'], ['Surface', 'Concrete pavers'], ['Base', 'Water-based']]
    },
    antiquing: {
      name: 'Antiquing™ Stamped Concrete Stain',
      tag: 'Stamped & textured concrete',
      look: 'Antiqued & dimensional',
      lookDesc: 'Adds depth while preserving a stamped or textured pattern',
      best: 'Best for restoring dimension to stamped or deeply textured exterior concrete.',
      trial: 'https://directcolors.com/products/stamped-concrete-stain-sample-kit',
      learn: 'https://directcolors.com/products/stamped-concrete-stain',
      price: '$39.95',
      benefits: [
        'Designed for stamped and deeply textured concrete',
        'Highlights the pattern instead of visually flattening it',
        'Revives faded patios, walkways and pool decks'
      ],
      specs: [['Use', 'Exterior'], ['Finish', 'Antiqued'], ['Surface', 'Stamped concrete'], ['Sealing', 'Required']]
    },
    decogel: {
      name: 'DecoGel™ Acid Stain',
      tag: 'Gel acid stain',
      look: 'Marbled on vertical surfaces',
      lookDesc: 'The acid-stain look in a gel that stays where it is brushed',
      best: 'Best for walls, fireplace surrounds, faces and other vertical concrete.',
      trial: 'https://directcolors.com/products/gel-acid-stain-sample-kit',
      learn: 'https://directcolors.com/products/gel-acid-stain',
      price: '$59.95',
      benefits: [
        'Gel formula clings to vertical and architectural concrete',
        'Creates translucent acid-stain movement and variation',
        'Useful for walls, faces, fireplace surrounds and concrete furniture'
      ],
      specs: [['Use', 'Vertical concrete'], ['Finish', 'Marbled'], ['Base', 'Gel acid stain'], ['Sealing', 'Required']]
    }
  };

  var GALLERIES = {
    everstain: 'https://directcolors.com/pages/before-and-after-gallery#EverStain',
    colorwave: 'https://directcolors.com/pages/before-and-after-gallery#ColorWave',
    vibrance: 'https://directcolors.com/pages/before-and-after-gallery#Vibrance',
    portico: 'https://directcolors.com/pages/before-and-after-gallery#Portico',
    pavewave: 'https://directcolors.com/pages/before-and-after-gallery#PaveWave',
    antiquing: 'https://directcolors.com/pages/before-and-after-gallery#Antiquing',
    decogel: 'https://directcolors.com/pages/before-and-after-gallery#DecoGel'
  };

  var PROJECTS = {
    indoor: [
      {
        id: 'basement', title: 'Basement floor', desc: 'Finished or unfinished living space',
        choices: [
          { stain: 'colorwave', photos: [CDN + 'Basement-ColorWave-1.webp?v=1781664758', CDN + 'Basement-ColorWave-2.webp?v=1781664757', CDN + 'Basement-ColorWave-3.webp?v=1781664757'] },
          { stain: 'everstain', photos: [CDN + 'Basement-EverStain-2.webp?v=1781664757', CDN + 'Basement-EverStain-3.webp?v=1781664757', CDN + 'Basement-EverStain-4.webp?v=1781664757'] },
          { stain: 'vibrance', photos: [CDN + 'Basement-Vibrance-1.webp?v=1781664757', CDN + 'Basement-Vibrance-2.webp?v=1781664757', CDN + 'Basement-Vibrance-3.webp?v=1781664757'] }
        ]
      },
      {
        id: 'garage', title: 'Garage floor', desc: 'Parking, workshop or hobby space',
        choices: [
          { stain: 'colorwave', photos: [CDN + 'Garage_-_ColorWave_-_1.webp?v=1781664774', CDN + 'Garage_-_ColorWave_-_2.webp?v=1781664776', CDN + 'Garage_-_ColorWave_-_3.webp?v=1781664775'] },
          { stain: 'everstain', photos: [CDN + 'Garage_-_EverStain_-_1.webp?v=1781664775', CDN + 'Garage_-_EverStain_-_2.webp?v=1781664775', CDN + 'Garage_-_EverStain_-_3.webp?v=1781664775'] },
          { stain: 'vibrance', photos: [CDN + 'Garage_-_Vibrance_-_1.webp?v=1781664775', CDN + 'Garage_-_Vibrance_-_2.webp?v=1781664775', CDN + 'Garage_-_Vibrance_-_3.webp?v=1781664775'] }
        ]
      },
      {
        id: 'interior-floor', title: 'Interior floor', desc: 'Living room, kitchen, loft or sunroom',
        choices: [
          { stain: 'colorwave', photos: [CDN + 'Interior_Floor_-_ColorWave_-_1.webp?v=1781664796', CDN + 'Interior_Floor_-_ColorWave_-_2.webp?v=1781664796', CDN + 'Interior_Floor_-_ColorWave_-_3.webp?v=1781664796'] },
          { stain: 'everstain', photos: [CDN + 'Interior_Floor_-_EverStain_-_1.webp?v=1781664796', CDN + 'Interior_Floor_-_EverStain_-_2.webp?v=1781664797', CDN + 'Interior_Floor_-_EverStain_-_3.webp?v=1781664797'] },
          { stain: 'vibrance', photos: [CDN + 'Interior_Floor_-_Vibrance_-_1.webp?v=1781664797', CDN + 'Interior_Floor_-_Vibrance_-_2.webp?v=1781664797', CDN + 'Interior_Floor_-_Vibrance_-_3.webp?v=1781664796'] }
        ]
      },
      {
        id: 'countertop', title: 'Countertop', desc: 'Kitchen, bath or concrete furniture top',
        choices: [
          { stain: 'everstain', photos: [CDN + 'Countertop_-_EverStain_-_1.webp?v=1781664811', CDN + 'Countertop_-_EverStain_-_2.webp?v=1781664811', CDN + 'Countertop_-_EverStain_-_3.webp?v=1781664811'] },
          { stain: 'colorwave', photos: [CDN + 'Countertop_-_ColorWave_-_1.webp?v=1781664811', CDN + 'Countertop_-_ColorWave_-_2.webp?v=1781664811', CDN + 'Countertop_-_ColorWave_-_3.webp?v=1781664811'] }
        ]
      },
      {
        id: 'interior-wall', title: 'Fireplace or wall', desc: 'Vertical and architectural concrete',
        choices: [
          { stain: 'decogel', photos: [CDN + 'Vertical_-_DecoGel_-_1.webp?v=1781664887', CDN + 'Vertical_-_DecoGel_-_2.webp?v=1781664887', CDN + 'Vertical_-_DecoGel_-_3.webp?v=1781664887'] }
        ]
      }
    ],
    outdoor: [
      {
        id: 'patio', title: 'Patio or walkway', desc: 'Poured concrete; choose pavers or stamped below if applicable',
        choices: [
          { stain: 'everstain', photos: [CDN + 'Patio_-_EverStain_-_1.webp?v=1781664826', CDN + 'Patio_-_EverStain_-_2.webp?v=1781664826', CDN + 'Patio_-_EverStain_-_3.webp?v=1781664826'] },
          { stain: 'colorwave', photos: [CDN + 'Patio_-_ColorWave_-_1.webp?v=1781664826', CDN + 'Patio_-_ColorWave_-_2.webp?v=1781664826', CDN + 'Patio_-_ColorWave_-_3.webp?v=1781664826'] }
        ]
      },
      {
        id: 'driveway', title: 'Driveway', desc: 'Poured concrete; choose pavers below if applicable',
        choices: [
          { stain: 'colorwave', photos: [CDN + 'Driveway_-_ColorWave_-_1.webp?v=1781664839', CDN + 'Driveway_-_ColorWave_-_2.webp?v=1781664840', CDN + 'Driveway_-_ColorWave_-_3.webp?v=1781664840'] },
          { stain: 'everstain', photos: [CDN + 'Driveway_-_EverStain_-_1.webp?v=1781664841', CDN + 'Driveway_-_EverStain_-_2.webp?v=1781664840', CDN + 'Driveway_-_EverStain_-_3.webp?v=1781664840'] }
        ]
      },
      {
        id: 'pool-deck', title: 'Pool deck', desc: 'Compare poured, stamped and paver finishes',
        choices: [
          { stain: 'colorwave', note: 'For poured concrete', photos: [CDN + 'Patio_-_ColorWave_-_1.webp?v=1781664826', CDN + 'Patio_-_ColorWave_-_2.webp?v=1781664826', CDN + 'Patio_-_ColorWave_-_3.webp?v=1781664826'] },
          { stain: 'everstain', note: 'For porous poured concrete', photos: [CDN + 'Patio_-_EverStain_-_1.webp?v=1781664826', CDN + 'Patio_-_EverStain_-_2.webp?v=1781664826', CDN + 'Patio_-_EverStain_-_3.webp?v=1781664826'] },
          { stain: 'antiquing', note: 'For stamped concrete', photos: [CDN + 'Pool_Deck_-_Antiquing_-_1.webp?v=1781664851', CDN + 'Pool_Deck_-_Antiquing_-_2.webp?v=1781664851', CDN + 'Pool_Deck_-_Antiquing_-_3.webp?v=1781674206'] },
          { stain: 'portico', note: 'For concrete pavers', photos: [CDN + 'Pool_Deck_-_Portico_-_1.webp?v=1781664852', CDN + 'Pool_Deck_-_Portico_-_2.webp?v=1781664852', CDN + 'Pool_Deck_-_Portico_-_3.webp?v=1781664852'] }
        ]
      },
      {
        id: 'pavers', title: 'Concrete pavers', desc: 'Choose this for paver patios, drives and pool decks',
        choices: [
          { stain: 'portico', photos: [CDN + 'Pavers_-_Portico_-_1.webp?v=1781664863', CDN + 'Pavers_-_Portico_-_2.webp?v=1781664863', CDN + 'Pavers_-_Portico_-_3.webp?v=1781664864'] },
          { stain: 'pavewave', photos: [CDN + 'Pavers_-_PaveWave_-_1.webp?v=1781664863', CDN + 'Pavers_-_PaveWave_-_2.webp?v=1781664863', CDN + 'Pavers_-_PaveWave_-_3.webp?v=1781664863'] }
        ]
      },
      {
        id: 'stamped', title: 'Stamped concrete', desc: 'Patterned patios, walkways and pool decks',
        choices: [
          { stain: 'antiquing', photos: [CDN + 'Stamped_-_Antiquing_-_1.webp?v=1781664873', CDN + 'Stamped_-_Antiquing_-_2.webp?v=1781664873', CDN + 'Stamped_-_Antiquing_-_3.webp?v=1781664873'] }
        ]
      },
      {
        id: 'exterior-wall', title: 'Exterior wall', desc: 'Retaining walls and other vertical concrete',
        choices: [
          { stain: 'decogel', photos: [CDN + 'Vertical_-_DecoGel_-_1.webp?v=1781664887', CDN + 'Vertical_-_DecoGel_-_2.webp?v=1781664887', CDN + 'Vertical_-_DecoGel_-_3.webp?v=1781664887'] }
        ]
      }
    ]
  };

  function esc(value) {
    return String(value).replace(/[&<>'"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
    });
  }

  function initQuiz(root) {
    if (!root || root.getAttribute('data-dcq-ready') === 'true') return;
    root.setAttribute('data-dcq-ready', 'true');

    var stage = root.querySelector('.dcq-stage');
    var progressTrack = root.querySelector('.dcq-progress-track');
    var progressFill = root.querySelector('.dcq-progress-fill');
    var progressLabel = root.querySelector('.dcq-progress-label');
    if (!stage || !progressTrack || !progressFill || !progressLabel) return;

    var config = {};
    var configEl = root.querySelector('[data-dcq-config]');
    if (configEl) {
      try { config = JSON.parse(configEl.textContent) || {}; } catch (error) { config = {}; }
    }
    function text(key, fallback) {
      return config[key] != null && String(config[key]).length ? String(config[key]) : fallback;
    }

    var LABELS = {
      q1Question: text('q1Question', 'Is your project indoors or outdoors?'),
      q1Hint: text('q1Hint', 'Start with where the finished project will live.'),
      q1IndoorTitle: text('q1IndoorTitle', 'Indoors'),
      q1IndoorDesc: text('q1IndoorDesc', 'Floors, basements, garages, countertops and fireplaces'),
      q1OutdoorTitle: text('q1OutdoorTitle', 'Outdoors'),
      q1OutdoorDesc: text('q1OutdoorDesc', 'Patios, driveways, pool decks, walkways, pavers and walls'),
      q2Question: text('q2Question', 'Which project are you staining?'),
      q2Hint: text('q2Hint', 'Choose the project that feels closest to yours.'),
      q3Question: text('q3Question', 'Which finish do you love?'),
      q3Hint: text('q3Hint', 'Choose the result you want for your'),
      progressQuestion: text('progressQuestion', 'Question'),
      progressFinal: text('progressFinal', 'Final question'),
      progressResult: text('progressResult', 'Your recommendation'),
      badge: text('badgeLabel', 'Your best match'),
      kicker: text('kickerPrefix', 'Recommended for your'),
      whyFits: text('whyFitsLabel', 'Why it fits:'),
      whyWorks: text('whyWorksLabel', 'Why it works'),
      basics: text('basicsLabel', 'The basics'),
      trial: text('trialLabel', 'Start with a Trial Kit'),
      trialSoldOut: text('trialSoldOutLabel', 'View Trial Kit'),
      consult: text('consultLabel', 'Get Free Project Guidance'),
      consultUrl: text('consultUrl', '#dcsf-consult'),
      offer: text('offerText', 'Trial kits ship free. A free consultation includes 15% off.'),
      learn: text('learnLabel', 'See product details'),
      gallery: text('galleryLabel', 'See real project results'),
      back: text('backLabel', '← Back'),
      reset: text('resetLabel', '↻ Change my answers')
    };

    var state = { environment: '', project: '', stain: '' };
    var quizStarted = false;

    function currentProject() {
      var list = PROJECTS[state.environment] || [];
      for (var i = 0; i < list.length; i += 1) {
        if (list[i].id === state.project) return list[i];
      }
      return null;
    }

    function setProgress(step, label) {
      progressTrack.setAttribute('aria-valuenow', String(step));
      progressFill.style.width = ((step / 3) * 100) + '%';
      progressLabel.textContent = label;
    }

    function focusQuestion() {
      var question = stage.querySelector('.dcq-question');
      if (!question) return;
      question.setAttribute('tabindex', '-1');
      try { question.focus({ preventScroll: true }); }
      catch (error) { question.focus(); }
    }

    function track(eventName, params) {
      var data = Object.assign({ quiz_version: 'project_first_v5' }, params || {});
      try {
        if (window.google_tag_manager && Array.isArray(window.dataLayer)) {
          window.dataLayer.push(Object.assign({ event: eventName }, data));
        } else if (typeof window.gtag === 'function') {
          window.gtag('event', eventName, data);
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: eventName }, data));
        }
      } catch (error) {}

      try {
        if (typeof window.clarity === 'function') {
          window.clarity('event', eventName);
          Object.keys(data).forEach(function (key) {
            window.clarity('set', 'dcq_' + key, String(data[key]));
          });
        }
      } catch (error) {}
    }

    function startOnce() {
      if (quizStarted) return;
      quizStarted = true;
      track('quiz_start', { placement: 'concrete_stains_funnel' });
    }

    function optionHtml(value, title, desc, dataName) {
      var attribute = dataName || 'data-environment';
      return '<button type="button" class="dcq-option" ' + attribute + '="' + esc(value) + '">' +
        '<span class="dcq-option-copy"><span class="dcq-option-title">' + esc(title) + '</span>' +
        '<span class="dcq-option-desc">' + esc(desc) + '</span></span>' +
      '</button>';
    }

    function renderQ1(shouldFocus) {
      state = { environment: '', project: '', stain: '' };
      setProgress(1, LABELS.progressQuestion + ' 1');
      stage.innerHTML =
        '<div class="dcq-panel">' +
          '<h3 class="dcq-question">' + esc(LABELS.q1Question) + '</h3>' +
          '<p class="dcq-hint">' + esc(LABELS.q1Hint) + '</p>' +
          '<div class="dcq-options">' +
            optionHtml('indoor', LABELS.q1IndoorTitle, LABELS.q1IndoorDesc) +
            optionHtml('outdoor', LABELS.q1OutdoorTitle, LABELS.q1OutdoorDesc) +
          '</div>' +
        '</div>';

      stage.querySelectorAll('[data-environment]').forEach(function (button) {
        button.addEventListener('click', function () {
          startOnce();
          state.environment = button.getAttribute('data-environment');
          track('quiz_answer', { step: 1, answer: state.environment });
          renderQ2(true);
        });
      });
      if (shouldFocus) focusQuestion();
    }

    function renderQ2(shouldFocus) {
      var projects = PROJECTS[state.environment] || [];
      setProgress(2, LABELS.progressQuestion + ' 2');
      var html = '';
      projects.forEach(function (project) {
        html += '<button type="button" class="dcq-project" data-project="' + esc(project.id) + '">' +
          '<span><span class="dcq-project-title">' + esc(project.title) + '</span>' +
          '<span class="dcq-project-desc">' + esc(project.desc) + '</span></span>' +
        '</button>';
      });

      stage.innerHTML =
        '<div class="dcq-panel">' +
          '<h3 class="dcq-question">' + esc(LABELS.q2Question) + '</h3>' +
          '<p class="dcq-hint">' + esc(LABELS.q2Hint) + '</p>' +
          '<div class="dcq-projects" style="--project-count:' + projects.length + '">' + html + '</div>' +
          '<div class="dcq-back-row"><button type="button" class="dcq-back" data-back>' + esc(LABELS.back) + '</button></div>' +
        '</div>';

      stage.querySelectorAll('[data-project]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.project = button.getAttribute('data-project');
          var project = currentProject();
          track('quiz_answer', { step: 2, environment: state.environment, answer: state.project });
          if (project && project.choices.length === 1) {
            state.stain = project.choices[0].stain;
            renderResult(true);
          } else {
            renderQ3(true);
          }
        });
      });
      stage.querySelector('[data-back]').addEventListener('click', function () { renderQ1(true); });
      if (shouldFocus) focusQuestion();
    }

    function renderQ3(shouldFocus) {
      var project = currentProject();
      if (!project || !project.choices.length) return renderQ2(shouldFocus);
      setProgress(3, LABELS.progressFinal);

      var html = '';
      project.choices.forEach(function (choice) {
        var stain = STAINS[choice.stain];
        var photos = choice.photos || [];
        var images = photos.map(function (photo, index) {
          return '<img src="' + esc(photo) + '" alt="' + esc(stain.look + ' ' + project.title + ' example ' + (index + 1)) + '" loading="lazy" width="420" height="300">';
        }).join('');
        html += '<button type="button" class="dcq-look" data-stain="' + esc(choice.stain) + '">' +
          '<span class="dcq-look-images" style="grid-template-columns:repeat(' + Math.max(photos.length, 1) + ',minmax(0,1fr))">' + images + '</span>' +
          '<span class="dcq-look-copy"><span class="dcq-look-title">' + esc(stain.look) + '</span>' +
          '<span class="dcq-look-desc">' + esc(stain.lookDesc) + '</span>' +
          (choice.note ? '<span class="dcq-look-note">' + esc(choice.note) + '</span>' : '') + '</span>' +
        '</button>';
      });

      stage.innerHTML =
        '<div class="dcq-panel">' +
          '<h3 class="dcq-question">' + esc(LABELS.q3Question) + '</h3>' +
          '<p class="dcq-hint">' + esc(LABELS.q3Hint) + ' <strong>' + esc(project.title.toLowerCase()) + '</strong>.</p>' +
          '<div class="dcq-looks" style="--look-count:' + Math.min(project.choices.length, 4) + '">' + html + '</div>' +
          '<div class="dcq-back-row"><button type="button" class="dcq-back" data-back>' + esc(LABELS.back) + '</button></div>' +
        '</div>';

      stage.querySelectorAll('[data-stain]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.stain = button.getAttribute('data-stain');
          track('quiz_answer', { step: 3, project: state.project, answer: state.stain });
          renderResult(true);
        });
      });
      stage.querySelector('[data-back]').addEventListener('click', function () { renderQ2(true); });
      if (shouldFocus) focusQuestion();
    }

    function selectedChoice(project, stainKey) {
      for (var i = 0; i < project.choices.length; i += 1) {
        if (project.choices[i].stain === stainKey) return project.choices[i];
      }
      return project.choices[0];
    }

    function renderResult(shouldFocus) {
      var project = currentProject();
      var stain = STAINS[state.stain];
      if (!project || !stain) return renderQ1(shouldFocus);
      setProgress(3, LABELS.progressResult);

      var choice = selectedChoice(project, state.stain);
      var photos = (choice && choice.photos) || [];
      var gallery = photos.slice(0, 3).map(function (photo, index) {
        return '<img src="' + esc(photo) + '" alt="' + esc(stain.name + ' on a ' + project.title + ' — example ' + (index + 1)) + '" loading="lazy" width="800" height="600">';
      }).join('');

      var benefits = stain.benefits.map(function (benefit) {
        return '<li>' + esc(benefit) + '</li>';
      }).join('');

      var specs = (stain.specs || []).map(function (spec) {
        return '<div><dt>' + esc(spec[0]) + '</dt><dd>' + esc(spec[1]) + '</dd></div>';
      }).join('');

      stage.innerHTML =
        '<div class="dcq-panel">' +
          '<div class="dcq-result-grid">' +
            '<div class="dcq-result-gallery">' + gallery +
              '<span class="dcq-result-badge">' + esc(LABELS.badge) + '</span>' +
            '</div>' +
            '<div class="dcq-result-copy">' +
              '<p class="dcq-kicker">' + esc(LABELS.kicker) + ' ' + esc(project.title) + '</p>' +
              '<h3 class="dcq-result-title dcq-question">' + esc(stain.name) + '</h3>' +
              '<p class="dcq-fit"><strong>' + esc(LABELS.whyFits) + '</strong> You chose the ' + esc(stain.look.toLowerCase()) + ' finish for your ' + esc(project.title.toLowerCase()) + '. ' + esc(stain.best) + '</p>' +
              '<div class="dcq-detail-grid">' +
                '<div class="dcq-detail-panel"><span class="dcq-detail-label">' + esc(LABELS.whyWorks) + '</span><ul class="dcq-benefits">' + benefits + '</ul></div>' +
                '<div class="dcq-detail-panel"><span class="dcq-detail-label">' + esc(LABELS.basics) + '</span><dl class="dcq-specs">' + specs + '</dl></div>' +
              '</div>' +
              '<div class="dcq-actions">' +
                '<a class="btn btn--primary" data-trial href="' + esc(stain.trial) + '"><span class="btn__text">' + esc(LABELS.trial + ' · ' + stain.price) + '</span></a>' +
                '<a class="btn btn--outline" data-consult href="' + esc(LABELS.consultUrl) + '"><span class="btn__text">' + esc(LABELS.consult) + '</span></a>' +
              '</div>' +
              '<p class="dcq-offer">' + esc(LABELS.offer) + '</p>' +
              '<div class="dcq-result-links">' +
                '<a class="dcq-text-link" data-learn href="' + esc(stain.learn) + '">' + esc(LABELS.learn) + '</a>' +
                '<a class="dcq-text-link" data-gallery href="' + esc(GALLERIES[state.stain]) + '">' + esc(LABELS.gallery) + '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="dcq-result-reset"><button type="button" class="dcq-back" data-reset>' + esc(LABELS.reset) + '</button></div>' +
        '</div>';

      track('quiz_complete', {
        environment: state.environment,
        project: state.project,
        recommendation: state.stain
      });

      stage.querySelector('[data-trial]').addEventListener('click', function () {
        track('quiz_trial_click', { recommendation: state.stain, project: state.project });
      });
      stage.querySelector('[data-consult]').addEventListener('click', function () {
        track('quiz_consult_click', { recommendation: state.stain, project: state.project });
      });
      stage.querySelector('[data-learn]').addEventListener('click', function () {
        track('quiz_product_click', { recommendation: state.stain });
      });
      stage.querySelector('[data-gallery]').addEventListener('click', function () {
        track('quiz_gallery_click', { recommendation: state.stain });
      });
      stage.querySelector('[data-reset]').addEventListener('click', function () {
        track('quiz_restart', { previous_recommendation: state.stain });
        renderQ1(true);
      });

      refreshTrialData(stain);
      if (shouldFocus) focusQuestion();
    }

    function formatMoney(cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function refreshTrialData(stain) {
      if (!window.fetch) return;
      var cta = stage.querySelector('[data-trial]');
      if (!cta) return;
      var label = cta.querySelector('.btn__text') || cta;

      try {
        var productPath = new URL(stain.trial, window.location.origin).pathname.replace(/\/$/, '') + '.js';
        window.fetch(productPath, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Product data unavailable');
            return response.json();
          })
          .then(function (product) {
            var livePrice = typeof product.price === 'number' ? formatMoney(product.price) : stain.price;
            label.textContent = (product.available ? LABELS.trial : LABELS.trialSoldOut) + ' · ' + livePrice;
          })
          .catch(function () { /* Keep the fallback price from the data map. */ });
      } catch (error) { /* Keep the fallback price from the data map. */ }
    }

    renderQ1(false);
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var roots = scope.querySelectorAll ? scope.querySelectorAll('[data-dcq-root]') : [];
    roots.forEach(function (root) { initQuiz(root); });
    if (context && context.matches && context.matches('[data-dcq-root]')) initQuiz(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
